import { useLocation, useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import single from '../../../assets/imgs/accommodations/single.jpg';
import double from '../../../assets/imgs/accommodations/double.jpg';
import superiorDouble from '../../../assets/imgs/accommodations/superior_double.jpg';
import scrollToPage from '../../../utils/scrollToPage';
import {
  ACCOMMODATIONS,
  BOOK_NOW_LINK,
  DOUBLE_ROOM,
  SINGLE_ROOM,
  SUPERIOR_DOUBLE_ROOM,
} from '../../../utils/constants';

interface Accommodation {
  accommodationtTitle: string;
  accommodationtText: string;
  accommodationtLink: string;
  accommodationtImage: string;
}

const Accommodations = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const accommodations: Array<Accommodation> = [
    {
      accommodationtTitle: 'Single',
      accommodationtText: 'SINGLE ROOM',
      accommodationtLink: SINGLE_ROOM,
      accommodationtImage: single,
    },
    {
      accommodationtTitle: 'Double',
      accommodationtText: 'DOUBLE ROOM',
      accommodationtLink: DOUBLE_ROOM,
      accommodationtImage: double,
    },
    {
      accommodationtTitle: 'Superior Double',
      accommodationtText: 'SUPERIOR DOUBLE ROOM',
      accommodationtLink: SUPERIOR_DOUBLE_ROOM,
      accommodationtImage: superiorDouble,
    },
  ];

  const slickSettings = {
    draggable: false,
    swipe: false,
    arrows: false,
    dots: true,
    fade: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    customPaging: (i: number) => (
      <div>{accommodations[i].accommodationtTitle}</div>
    ),
  };

  return (
    <div id={ACCOMMODATIONS} className='accommodations'>
      <div className='accommodations_container container'>
        <h2 data-aos='fade-up' className='text_center'>
          ACCOMODATION
        </h2>
        <h3
          data-aos='fade-up'
          data-aos-delay='50'
          className='title_underline_dark_small'
        >
          LIKE HOME AWAY FROM HOME
        </h3>
        <p data-aos='fade-up' data-aos-delay='100'>
          Accommodation offered in 9 double rooms and 3 single rooms will make
          every guest feel comfortable.
        </p>
        <div data-aos='fade-up' data-aos-delay='150'>
          <Slider {...slickSettings} className='accommodations_container_slick'>
            {accommodations.map((x: Accommodation) => (
              <div className='accommodations_container_slick_container'>
                <img
                  src={x.accommodationtImage}
                  alt={x.accommodationtTitle}
                  className='accommodations_container_slick_container_image'
                />
                <div
                  data-index={`${accommodations.indexOf(x)}`}
                  className='accommodations_container_slick_container_box'
                >
                  <div className='accommodations_container_slick_container_box_title title_underline_complementary_small'>
                    {x.accommodationtText}
                  </div>
                  <div className='accommodations_container_slick_container_box_links'>
                    <a href={BOOK_NOW_LINK} target='_blank' rel='noreferrer'>
                      <div>BOOK NOW</div>
                    </a>
                    <div
                      onClick={() =>
                        scrollToPage(
                          x.accommodationtLink,
                          location,
                          navigate,
                          true
                        )
                      }
                    >
                      SHOW MORE
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Accommodations;
